import Translations from '@helpers/translations'
import { ReactComponent as WaistIcon } from '@svgs/illustration/waist.svg'
import { ReactComponent as RiseIcon } from '@svgs/illustration/rise.svg'
import { ReactComponent as ThighIcon } from '@svgs/illustration/thigh.svg'
import { ReactComponent as KneeIcon } from '@svgs/illustration/knee.svg'
import { ReactComponent as LegIcon } from '@svgs/illustration/leg.svg'
import styles from './styles.module.scss'

export const data = [
  {
    classes: styles.tab__content,
    text: 'waist',
    icon: (
      <WaistIcon name="waist" width="260" height="162" viewBox="0 0 343 213" />
    ),
    description: Translations.localise('pages.size-chart.htm.waist.desc'),
    subTitle: (
      <>
        {Translations.localise('pages.size-chart.htm.waist.subtitle-1')}{' '}
        <span style={{ color: '#f9491f' }}>
          {' '}
          {Translations.localise('pages.size-chart.htm.waist.subtitle-2')}
        </span>
      </>
    )
  },
  {
    classes: styles.tab__content,
    text: 'rise',
    icon: (
      <RiseIcon name="rise" width="235" height="196" viewBox="0 0 340 340" />
    ),
    description: Translations.localise('pages.size-chart.htm.rise.desc'),
    subTitle: (
      <>
        {Translations.localise('pages.size-chart.htm.rise.subtitle-1')}{' '}
        <span style={{ color: '#f9491f' }}>
          {Translations.localise('pages.size-chart.htm.rise.subtitle-2')}
        </span>
      </>
    )
  },
  {
    classes: styles.tab__content,
    text: 'thigh',
    icon: (
      <ThighIcon name="thigh" width="260" height="201" viewBox="0 0 340 340" />
    ),
    description: Translations.localise('pages.size-chart.htm.thigh.desc'),
    subTitle: (
      <>
        {Translations.localise('pages.size-chart.htm.thigh.subtitle-1')}{' '}
        <span style={{ color: '#f9491f' }}>
          {Translations.localise('pages.size-chart.htm.thigh.subtitle-2')}{' '}
        </span>
      </>
    )
  },
  {
    classes: styles.tab__content,
    text: 'knee',
    icon: (
      <KneeIcon name="knee" width="270" height="169" viewBox="0 0 340 340" />
    ),
    description: Translations.localise('pages.size-chart.htm.knee.desc'),
    subTitle: (
      <>
        {Translations.localise('pages.size-chart.htm.knee.subtitle-1')}{' '}
        <span style={{ color: '#f9491f' }}>
          {Translations.localise('pages.size-chart.htm.knee.subtitle-2')}{' '}
        </span>
      </>
    )
  },
  {
    classes: styles.tab__content,
    text: 'leg',
    icon: <LegIcon name="leg" width="275" height="219" viewBox="0 0 340 340" />,
    description: Translations.localise('pages.size-chart.htm.leg.desc'),
    subTitle: (
      <>
        {Translations.localise('pages.size-chart.htm.leg.subtitle-1')}{' '}
        <span style={{ color: '#f9491f' }}>
          {Translations.localise('pages.size-chart.htm.leg.subtitle-2')}
        </span>
      </>
    )
  }
]
